import React, { SVGProps } from "react";

const SvgElectricScooter = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      className="svg-icon"
      {...props}
    >
      <path fill="none" d="M0 0h24v24H0z" />
      <path d="M7.82 16H15v-1c0-2.21 1.79-4 4-4h.74l-1.9-8.44A2.009 2.009 0 0015.89 1H12v2h3.89l1.4 6.25h-.01A6.008 6.008 0 0013.09 14H7.82a2.996 2.996 0 00-3.42-1.94c-1.18.23-2.13 1.2-2.35 2.38A3.002 3.002 0 005 18c1.3 0 2.4-.84 2.82-2zM5 16c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z" />
      <path d="M19 12c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm0 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM11 20H7l6 3v-2h4l-6-3z" />
    </svg>
  );
};

export default SvgElectricScooter;
